import { isEmptyObjectCheck } from '@/utils/utils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'common-upload-file',
})

export default class CommonUploadFile extends Vue {
    @Prop()
    private bindAt: any;

    @Prop()
    private itemData: any;

    private isUploading: boolean = false;


    private get imageURL() {
        const fieldObj = this.itemData;
        const modelValue = isEmptyObjectCheck(this.itemData.modelValue) ? '' : this.itemData.modelValue;
        return modelValue;
    }
}
